export default {
    isConfig: false,
    isLoaded: false,
    game_name: '',
    activeTab: 0,
    currentCateId: 0,
    currentPage: 1,
    stateLoading: false,
    stateFinished: true,
    pageSize: 10,
    logo: '',
    is_logo: 0,
    qrcode: '',
    is_qrcode: 0,
    apk_link: '',
    top_game_icon: '',
    top_background: '',
    top_down_button: '',
    home_image: '',
    home_down_image: '',
    feature: '',
    promotional_video: '',
    bottom_info: '',
    articleList: []
}


// WEBPACK FOOTER //
// ./src/store/state.js